import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//cookie
import { removeCookie } from "src/webapp/config/cookie";
//bottomSheet
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'src/asset/scss/plugin/bottomsheet/style.scss';
import 'src/asset/scss/plugin/bottomsheet/bottomsheet.scss';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/style/user.mypage.module.scss'
//image
import onWarning_Img from 'src/asset/images/icon/common-warning.webp';
//store
import usePartnerStore from "src/webapp/stores/partner.store";

export default function BsSearchDate(props) {
	const { isOpen } = props;//props
	const { axiosPostHandler } = useAxiosHook();//axios
	const navigator = useNavigate();//navigatore
	const { partner, setPartner, setState } = usePartnerStore();//store
	
	/* =============== 회원탈퇴API =============== */
	const [ isSubmit, setSubmit ] = useState(false);
    const partnerWithdrawAPI = async() => {
        if(isSubmit || !window.confirm("회원 탈퇴 후 복구가 어려울 수 있습니다.\n정말 탈퇴하시겠습니까?")) { return; }

        setSubmit(true);
        const DATA = { PARTNER_CD:partner.COMN_CD, STATE:9 };
		const result = await axiosPostHandler(`partnerMasterUpdateForPartner.do`, DATA);
		setTimeout(function() { setSubmit(false); }, 300);
		if(!result || result.message !== "SUCCESS") { return; }
		if(result.message === "SUCCESS") {
			removeCookie("NIDAP");
			removeCookie("NIDRP");
	
			setState(false);
			setPartner({});

			navigator("/", { replace: true });

			props.onDismiss(false);
		}
    };
	/* =============== 회원탈퇴API =============== */

	return (
		<BottomSheet open={isOpen} onDismiss={(e) => props.onDismiss(false)}
			className={'bottomsheetContainer'}
			header={
				<button className={'bottomsheetDissmissButton'} onClick={(e) => props.onDismiss(false, null)}><FontAwesomeIcon icon="fa-light fa-xmark" /></button>
			}
			footer={
				<div style={{marginTop:'3.75rem'}} className={styles.bottomsheePartnerWithdrawBtnArea}>
					<button onClick={(e) => partnerWithdrawAPI()} className={styles.btnSubmit}>탈퇴하기</button>
					<button onClick={(e) => props.onDismiss(false)} className={styles.btnCancel}>취소</button>
                </div>
            }
			snapPoints={({ maxHeight }) => maxHeight}
			skipInitialTransition={false} scrollLocking={false} expandOnContentDrag={true}>
			<div className={styles.bottomsheetPartnerWithdrawContainer}>
				<h1>회원탈퇴를 진행 하시겠습니까?</h1>
				<p>회원탈퇴를 하시면 기존 계정에 있는 정보가 모두 삭제됩니다. 그래도 탈퇴하시겠습니까? </p>
				<div className={styles.imgArea}><img src={onWarning_Img} alt={'DUBAKI PARTNERS'} /></div>
			</div>
		</BottomSheet>
	)
}